import { Directive, ElementRef, Host, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, filter, fromEvent, Subject, takeUntil } from 'rxjs';
import { AutofocusDirective } from '../../basics/models/bosch-ui-autofocus-directive.interface';

@Directive({
  selector: '[boschUiInputAutofocus]',
  standalone: true,
})
export class BoschUiInputAutofocusDirective implements OnInit, OnDestroy, AutofocusDirective {
  @Input() set boschUiInputAutofocus(autofocus: boolean) {
    this._autofocus$.next(autofocus);
  }

  private _autofocus$ = new BehaviorSubject<boolean>(false);
  private _unsubscribe$ = new Subject<void>();

  constructor(@Host() private input: ElementRef) {}

  ngOnInit(): void {
    this._autofocus$
      .pipe(filter(Boolean), takeUntil(this._unsubscribe$))
      .subscribe(() => this.input.nativeElement.focus());

    fromEvent(this.input.nativeElement, 'blur')
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => this._autofocus$.next(false));
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
  }

  public focus(): void {
    this._autofocus$.next(true);
  }
}
